export default __webpack_public_path__ + "static/media/thothamonstrongholdsecondfloor.a259f971.jpg";